window.selectedVariant = '';

jQuery(document).ready(function() {
    (function(window, $, Vue) {
        const data = {
            product: window.productJSON,
            offers: window.upsell,
        };

        var offerComponent = {
            name: 'offer',
            props: {
                product: Object,
                purchases: Object,
                selected_variant: String,
                quantity: Number
            },
            data: function() {
                return {
                    purchase: false,
                    show_modal: false
                }
            },
            computed: {
                product_data: function() {
                    let _product = this.product;

                    if (this.selected_variant !== '' && this.product.variants.length > 0) {
                        let _this = this;

                        this.product.variants.forEach(function(product, index) {
                            if (product.option1 === _this.selected_variant) {
                                _product = product;
                            }
                        });
                    }

                    return _product;
                },
                price: function() {
                    return ((this.product_data.price * this.quantity) / 100);
                }
            },
            watch: {
                product_data: function(new_value, old_value) {
                    if (new_value.id !== old_value.id) {
                        this.purchase = false;
                    }
                }
            },
            methods: {
                toggle: function() {
                    this.purchase = !this.purchase;
                    this.$parent.$emit('toggle-purchase', this.product, this.product_data);
                }
            }
        };

        Vue.component('modal', {
            props: {
                'data': Object,
            },
            computed: {
                title: function() {
                    if (!this.has('title')) {
                        return '';
                    }

                    return this.data.title;
                },
                price: function() {
                    if (!this.has('price')) {
                        return '';
                    }

                    return '$' + (this.data.price / 100);
                },
                content: function() {
                    if (!this.has('content')) {
                        return '';
                    }

                    return this.data.content;
                }
            },
            methods: {
                has: function(field) {
                    if (this.data !== undefined && Object.keys(this.data).length > 0) {
                        if (this.data[field] !== undefined) {
                            return this.data[field];
                        }
                    }

                    return '';
                },
            },
            template: '#upsell-view'
        });

        Vue.component('offers', {
            name: 'offers',
            props: {
                'product': Object,
                'offers': Array
            },
            components: {
                'offer': offerComponent,
            },
            data: function() {
                return {
                    variant: 'Twin',
                    purchases: {},
                    price: 0.00,
                    quantity: 1
                }
            },
            computed: {
                options: function () {
                    let options = [];

                    this.product.variants.forEach(function (variant) {
                        options.push(variant.option1);
                    });

                    return options;
                },
                variant_product: function() {
                    let product = null;
                    const _this = this;

                    if (this.options.length > 0 && this.variant !== '') {
                        let v = this.product.variants;
                        v.forEach(function(variant) {
                            console.log("Evaluating variant", variant);
                            if (variant.option1 === _this.variant) {
                                product = variant;
                            }
                        });
                    } else {
                        product = this.product;
                    }

                    return product;
                }
            },
            created: function() {
                const _this = this;
                this.$on('toggle-purchase', this.toggle);
                $('.product-price .price').hide();

                $(document).ready(function() {
                    $('.add-to-cart-button').click(this.checkout);

                    $('.icon-plus').click(function(e) {
                        e.preventDefault();
                        _this.quantity += 1;
                    });

                    $('.icon-minus').click(function(e) {
                        e.preventDefault();

                        if (_this.quantity > 1) {
                            _this.quantity -=1;
                        } else {
                            alert("Minimum quantity of 1.");
                        }
                    });

                    _this.update_price();
                });
            },
            watch: {
                variant: function(new_value, old_value) {
                    if (new_value !== old_value) {
                        console.log("Resetting variant");
                        this.purchases = {};
                        this.update_price();

                        $('.button-variant-wrapper')
                            .find('div[data-value="' + new_value + '"]')
                            .find('div')
                            .trigger('click');
                    }
                },
                purchases: function(new_value, old_value) {
                    if (new_value.length !== old_value.length) {
                        this.update_price();
                    }
                },
                quantity: function(new_value, old_value) {
                    if (new_value !== old_value && new_value !== undefined && new_value !== '') {
                        this.update_price();
                        $('#quantity').val(new_value);
                        this.$forceUpdate();
                    }
                }
            },
            methods: {
                select_variant: function(variant) {
                    this.variant = variant;
                },

                btn_class: function(variant) {
                    var classes = 'button button-variant';

                    if (this.variant === variant) {
                        classes += " selected";
                    }

                    return classes;
                },

                get_variant_price: function(variation) {
                    var price = 0.00;
                    var variant = null;

                    this.product.variants.forEach(function(v) {
                        if (v.option1 === variation) {
                            variant = v;
                        }
                    });

                    if (variant !== null) {
                        price += variant.price / 100;
                    }

                    if (price <= 0.00) {
                        return '';
                    }

                    return '- $' + price;
                },

                update_price: function() {
                    this.price = this.calculate_price();
                },

                calculate_price: function() {
                    console.log("Calculating price");

                    const _this = this;
                    let price = 0.00;
                    price += this.variant_product.price;

                    let purchase_product_ids = Object.values(this.purchases);
                    console.log(purchase_product_ids);
                    purchase_product_ids.forEach(function(variant) {
                        price += variant.price;
                    });

                    price = ((price * this.quantity ) / 100);
                    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                },

                toggle: function(product, variant) {
                    if (this.purchases[product.id] === undefined) {
                        console.log("Adding purchase", product.id, this.purchases);
                        this.purchases[product.id] = variant;
                    } else {
                        console.log("Deleting purchase");
                        delete this.purchases[product.id];
                    }

                    this.update_price();
                },

                checkout: function(e) {
                    const _this = this;
                    const ids = Object.keys(this.purchases);

                    if (ids.length === 0) {
                        console.log("No upsells. Default functionality.");
                        return true;
                    }

                    e.preventDefault();

                    // set the variation
                    $('#quantity').val(this.quantity);

                    // Add upsold products to the cart
                    Shopify.queue = [];

                    ids.forEach(function(id) {
                        const product = _this.purchases[id];
                        console.log(product.id, id);

                        Shopify.queue.push({
                            quantity: _this.quantity,
                            id: product.id
                        });
                    });

                    Shopify.queue.push({
                        quantity: _this.quantity,
                        id: _this.variant_product.id
                    });

                    Shopify.moveAlong = function() {
                        // If we still have requests in the queue, let's process the next one.
                        if (Shopify.queue.length) {
                            var request = Shopify.queue.shift();
                            Shopify.addItem(request.id, request.quantity, Shopify.moveAlong);
                        } else {
                            document.location.href = '/cart';
                        }
                    };

                    Shopify.moveAlong();
                }
            }
        });

        window.app = new Vue({
            el: '#vue-app',
            data: {
                product: data.product,
                offers: data.offers
            }
        });
    })(window, jQuery, Vue);
});

